// src/hooks/useSurveys.jsx
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import SurveysService from "../service/surveys";
import HttpClient from "../network/http";
import { fetchCsrfToken, useAuthContext } from "../context/AuthContext";

const baseURL = process.env.REACT_APP_BASE_URL;

export default function useSurveys(conditions) {
  const { address } = useAuthContext();
  const httpClient = new HttpClient(baseURL, () => fetchCsrfToken(), address);
  const surveysService = new SurveysService(httpClient);
  const queryClient = useQueryClient();

  const surveysQuery = useQuery(
    ["surveys", conditions],
    () => surveysService.findAllSurveys(conditions),
    {
      enabled: !!conditions?.schoolid,
      staleTime: 1000 * 60 * 1, // 1분
      onError: (error) => {
        console.error("설문 조회 오류:", error);
      },
    }
  );

  const createSurvey = useMutation(
    (data) => surveysService.createSurvey(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["surveys", conditions]);
      },
      onError: (error) => {
        console.error("설문 생성 오류:", error);
      },
    }
  );

  const updateSurvey = useMutation(
    (data) => surveysService.updateSurvey(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["surveys", conditions]);
      },
      onError: (error) => {
        console.error("설문 수정 오류:", error);
      },
    }
  );

  const deleteSurvey = useMutation((id) => surveysService.deleteSurvey(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(["surveys", conditions]);
    },
    onError: (error) => {
      console.error("설문 삭제 오류:", error);
    },
  });

  const createOrUpdateSurveySubjectLink = useMutation(
    (data) => surveysService.createOrUpdateSurveySubjectLink(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["surveys", conditions]);
      },
    }
  );

  return {
    surveysQuery,
    createSurvey,
    updateSurvey,
    deleteSurvey,
    createOrUpdateSurveySubjectLink,
  };
}
